export default __webpack_public_path__ + "static/media/warning--falling-rocks-or-debris-left--g4.21007872.png";